import React from "react";
import { TID } from "@/lib/testIds";
import { Wallet, TrendingUp, Layers, Percent } from "lucide-react";

export default function PortfolioSummary({ portfolio, settings }) {
  const pl = portfolio.unrealized_pl;
  const plUp = pl >= 0;
  const totalUp = portfolio.total_return_pct >= 0;
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-[11px] font-mono text-slate-500">
        <span className="uppercase tracking-[0.2em]">Paper capital</span>
        <span className="text-slate-600">·</span>
        <span>TradingoX does not hold your money — your broker does.</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Metric icon={<Wallet className="w-4 h-4 text-slate-400" />} label="Net worth" value={`$${portfolio.net_worth.toLocaleString()}`} sub={`${totalUp ? "+" : ""}${portfolio.total_return_pct}% all-time`} subColor={totalUp ? "text-emerald-300" : "text-rose-300"} testid={TID.portfolioNetWorth} />
      <Metric icon={<Layers className="w-4 h-4 text-slate-400" />} label="Cash" value={`$${portfolio.cash.toLocaleString()}`} sub={`${portfolio.positions.length} open positions`} testid={TID.portfolioCash} />
      <Metric icon={<TrendingUp className={`w-4 h-4 ${plUp ? "text-emerald-400" : "text-rose-400"}`} />} label="Unrealized P/L" value={`${plUp ? "+" : ""}$${pl.toLocaleString()}`} valueColor={plUp ? "text-emerald-300" : "text-rose-300"} sub={`Market $${portfolio.market_value.toLocaleString()}`} testid={TID.portfolioPL} />
      <Metric icon={<Percent className="w-4 h-4 text-indigo-300" />} label="Bot config" value={`${settings.confidence_threshold}%`} sub={`Risk ${settings.risk_tolerance}/10 · Size ${settings.position_size_pct}%`} />
      </div>
    </div>
  );
}

function Metric({ icon, label, value, sub, subColor = "text-slate-500", valueColor = "text-slate-100", testid }) {
  return (
    <div className="aq-card p-4">
      <div className="flex items-center justify-between">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{label}</div>
        {icon}
      </div>
      <div data-testid={testid} className={`mt-2 font-display text-xl md:text-2xl font-bold font-mono ${valueColor}`}>{value}</div>
      <div className={`mt-1 text-[11px] font-mono ${subColor}`}>{sub}</div>
    </div>
  );
}
